
export const KEY_NAME_CODES = {
  ARROW_LEFT: 'ArrowLeft',
  ARROW_UP: 'ArrowUp',
  ARROW_RIGHT: 'ArrowRight',
  ARROW_DOWN: 'ArrowDown',
  ENTER: 'Enter',
  ESCAPE: 'Escape',
  CONTROL: 'Control',
  SHIFT: 'Shift',
  ALT: 'Alt',
  META: 'Meta',
  HOME: 'Home',
  END: 'End'
};

export const AUTOFOCUS_DELAY = 400;
export const TOGGLE_SEARCH_PAGE_DELAY = 100;
